<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Crédit</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_financement.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <table>
                <tr>
                    <th>Apport</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Apport</mat-label>
                            <input matInput [(ngModel)]="favorite.apport" (ngModelChange)="edit($event)">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Montant emprunté</th>
                    <td>{{ favorite.loaning |number:'1.0-1'}} €</td>
                </tr>
                <tr>
                    <th>Frais bancaires</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Frais bancaires</mat-label>
                            <input matInput [(ngModel)]="favorite.banking_fees" (ngModelChange)="edit($event)">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Frais de cautionnement</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Frais de cautionnement</mat-label>
                            <input matInput [(ngModel)]="favorite.deposit_fees" (ngModelChange)="edit($event)">
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Taux crédit</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Taux du crédit</mat-label>
                            <input matInput [(ngModel)]="favorite.rate" (ngModelChange)="edit($event)">
                            <span matSuffix>%</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Taux assurance</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Taux assurance</mat-label>
                            <input matInput [(ngModel)]="favorite.rate_insurance" (ngModelChange)="edit($event)">
                            <span matSuffix>%</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Durée</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Durée</mat-label>
                            <input matInput [(ngModel)]="favorite.duration" (ngModelChange)="edit($event)">
                            <span matSuffix>ans</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Annuité</th>
                    <td>{{ favorite.monthly * 12|number:'1.0-1'}} €</td>
                </tr>
                <tr>
                    <th>Mensualité</th>
                    <td>{{ favorite.monthly|number:'1.0-1'}} €</td>
                </tr>
            </table>
        </div>
    </div>
</div>
